import { createSelector } from 'reselect';

export const getBlogs = state => state.blogs;

export const getIsBlogsFetching = createSelector(
  getBlogs,
  blogs => blogs.isFetching
);

export const getIsBlogsInitialized = createSelector(
  getBlogs,
  blogs => blogs.isInitialized
);

export const getBlogsEntities = createSelector(
  getBlogs,
  blogs => blogs?.items || {}
);
